export const START_MESSAGE_TYPE = 'start_progress_bar';
export const FINISH_MESSAGE_TYPE = 'finish_progress_bar';
